import { Link } from '@inertiajs/react'
import { Badge } from '@/components/design-system'
import { EMPTY, formatDate } from '@/frontend/pages/CommandCenter/Organizations/components/organizationFormatting'
import type { SubscriptionRow } from '@/frontend/pages/CommandCenter/Organizations/components/organizationDetailTypes'

interface Props {
  subscriptions: SubscriptionRow[]
}

export default function SubscriptionsTable({ subscriptions }: Props) {
  return (
    <section className="rounded-lg border border-border bg-card">
      <div className="border-b border-border px-4 py-3">
        <h3 className="text-base font-semibold text-foreground">Assinaturas dos agentes</h3>
      </div>
      <div className="overflow-auto">
        <table className="w-full">
          <thead className="bg-muted">
            <tr>
              <th className="px-4 py-3 text-left text-xs font-medium text-muted-foreground">Agente</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-muted-foreground">Plano</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-muted-foreground">Status</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-muted-foreground">Stripe</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-muted-foreground">Período</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {subscriptions.map((subscription) => (
              <tr key={subscription.id}>
                <td className="px-4 py-3">
                  <Link href={`/cc/digital_workers/${subscription.worker_id}`} className="text-sm font-medium text-foreground hover:text-blue-600">
                    {subscription.worker_name}
                  </Link>
                </td>
                <td className="px-4 py-3">
                  <div className="text-sm text-foreground">{subscription.plan_name}</div>
                  <div className="font-mono text-xs text-muted-foreground">{subscription.plan_slug}</div>
                </td>
                <td className="px-4 py-3">
                  <div className="flex flex-wrap gap-1">
                    <Badge tone={subscription.source === 'stripe' ? 'info' : 'success'}>
                      {subscription.source === 'stripe' ? 'Stripe' : 'Cortesia'}
                    </Badge>
                    <Badge>{subscription.status}</Badge>
                  </div>
                </td>
                <td className="px-4 py-3 font-mono text-xs text-muted-foreground">
                  <div>{subscription.stripe_customer_id || EMPTY}</div>
                  <div>{subscription.stripe_subscription_id || EMPTY}</div>
                  <div>{subscription.stripe_subscription_item_id || EMPTY}</div>
                  <div>{subscription.stripe_price_id || EMPTY}</div>
                </td>
                <td className="px-4 py-3 text-xs text-muted-foreground">
                  <div>{formatDate(subscription.current_period_start)} → {formatDate(subscription.current_period_end)}</div>
                  {subscription.canceled_at && <div>Cancelada em {formatDate(subscription.canceled_at)}</div>}
                </td>
              </tr>
            ))}
            {subscriptions.length === 0 && (
              <tr>
                <td colSpan={5} className="px-4 py-8 text-center text-sm text-muted-foreground">Nenhuma assinatura vinculada.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </section>
  )
}
